import { render, staticRenderFns } from "./school-line.vue?vue&type=template&id=8fefd43e&scoped=true"
import script from "./school-line.vue?vue&type=script&lang=js"
export * from "./school-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fefd43e",
  null
  
)

export default component.exports